import { Directive, OnDestroy } from '@angular/core';

import { Subject } from 'rxjs';

@Directive()
export class TakeUntilDestroy implements OnDestroy {
  protected unsubscribe$: Subject<void> = new Subject<void>();

  public ngOnDestroy() {
    this.unsubscribe();
  }

  protected unsubscribe(): void {
    if (!this.unsubscribe$.isStopped || !this.unsubscribe$.closed) {
      this.unsubscribe$.next();
      this.unsubscribe$.complete();
    }
  }
}
